<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="filter-container">
      <!-- 游戏 -->
      <div class="game-filter filter-item">
        <div class="label">游&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;戏：</div>
        <el-select size="small" v-model="appkey" filterable clearable placeholder="请选择" @change="handleFilter">
          <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
        </el-select>
      </div>

      <!-- 快捷键时间 -->
      <hotkey-time class="filter-item" ref="hotkey" style="display:inline-flex" @refreshCallback="handleFilter"></hotkey-time>

      <!-- 查询 -->
      <!-- <el-button class="filter-item" size="small" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button> -->
    </div>

    <!-- 数据图标总览 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>数据总览</span>
      </div>
      <el-row class="chart-box" :gutter="24">
        <!-- 消耗总览查询 -->
        <el-col :md="24" :lg="12">
          <el-card class="item-box" v-if="activationData">
            <div slot="header" class="title-box">
              <span class="title">{{activationData.title}}</span>
              <span class="subtitle">{{activationData.subtitle.lable}}: {{activationData.subtitle.value}}</span>
            </div>
            <line-chart ref="activationChart" :chartData="activationData"></line-chart>
          </el-card>
           <div v-else style="text-align:center; color:#b1adad; line-height:100px">
              暂无数据！
            </div>
        </el-col>

      </el-row>
    </el-card>

    <!-- 效果总览 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>效果总览</span>
      </div>
      <el-row class="chart-box" :gutter="24">
        <!--  注册趋势 -->
        <el-col :md="24" :lg="12">
          <el-card class="item-box" v-if="regTrendData">
            <div slot="header" class="title-box">
              <span class="title">{{regTrendData.title}}</span>
              <span class="subtitle">{{regTrendData.subtitle.lable}}: {{regTrendData.subtitle.value}}</span>
            </div>
            <line-chart :chartData="regTrendData"></line-chart>
          </el-card>
           <div v-else style="text-align:center; color:#b1adad; line-height:100px">
              暂无数据！
            </div>
        </el-col>

        <!--  推广注册成本 -->
        <el-col :md="24" :lg="12">
          <el-card class="item-box" v-if="regCostData">
            <div slot="header" class="title-box">
              <span class="title">{{regCostData.title}}</span>
              <span class="subtitle">{{regCostData.subtitle.lable}}: {{regCostData.subtitle.value}}</span>
            </div>
            <line-chart :chartData="regCostData"></line-chart>
          </el-card>
           <div v-else style="text-align:center; color:#b1adad; line-height:100px">
              暂无数据！
            </div>
        </el-col>

        <!--  收入趋势 -->
        <el-col :md="24" :lg="12">
          <el-card class="item-box" v-if="payTrendData">
            <div slot="header" class="title-box">
              <span class="title">{{payTrendData.title}}</span>
              <span class="subtitle">{{payTrendData.subtitle.lable}}: {{payTrendData.subtitle.value}}</span>
            </div>
            <line-chart :chartData="payTrendData"></line-chart>
          </el-card>
           <div v-else style="text-align:center; color:#b1adad; line-height:100px">
              暂无数据！
            </div>
        </el-col>

        
      </el-row>
    </el-card>

     <!-- 渠道指标 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>渠道指标</span>
      </div>
      <el-row class="chart-box" :gutter="24">
      </el-row>
    </el-card>

  </div>
</template>

<script>
import HotkeyTime from '@Sys~/components/HotkeyTime'
import LineChart from './components/LineChart'

import {ajax_filterGame} from '@Sys~/api/sys'

import {find_recordCost, find_payTrend, find_regTrend, find_regCost} from '@Sys~/api/sys'

import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name

const defaultCart = {
  dataList:[],
  server:[],
  subtitle:{},
  title:'',
  xaxis:[]
}

export default {
  name:name,
  components: {HotkeyTime, LineChart},
  data() {
    return {
      gameOptions:[], // 游戏列表
      appkey:'', // 当前游戏 

      activationData:defaultCart, // 消耗总览
      payTrendData: defaultCart, // 收入趋势
      regTrendData: defaultCart, // 注册趋势
      regCostData: defaultCart, // 推广注册成本
    }
  },

  created() {
    this.getGameList() // 获取游戏列表
  },

  methods: {

    // 获取游戏列表
    getGameList() {
      ajax_filterGame().then(response => {
        if(response.code == 1) {
          this.gameOptions = response.data
          this.appkey = response.data[0].appkey
          this.get_recordView() // 获取消耗总览数据
          this.get_payTrend() // 收入趋势
          this.get_regTrend() // 注册趋势
          this.get_regCost() // 推广注册成本
        }
      })
    },

    // 获取消耗总览数据
    get_recordView() {
      // console.log('重新加载数据', this.$refs['hotkey'])
      const data = {
        appkey: this.appkey,
        startDate: this.$refs['hotkey'].selecttime[0],
        endDate: this.$refs['hotkey'].selecttime[1], 
      }
      find_recordCost(data).then(response => {
        if(response.code == 1) {
          if(response.data) {
            this.activationData = {
              dataList:response.data.dataList,
              server:response.data.server,
              subtitle:response.data.subtitle,
              title:response.data.title,
              xaxis:response.data.xaxis 
            }
          } else {
            this.activationData = null
          }
          
          // console.log('11111111111chart-data:', this.activationData)
          // this.$refs['activationChart'].initChart()
        }
      })
    },

    // 收入趋势
    get_payTrend() {
      const data = {
        appkey: this.appkey,
        startDate: this.$refs['hotkey'].selecttime[0],
        endDate: this.$refs['hotkey'].selecttime[1], 
      }
      find_payTrend(data).then(response => {
        if(response.code == 1) {
          if(response.data) {
            this.payTrendData = {
              dataList:response.data.dataList,
              server:response.data.server,
              subtitle:response.data.subtitle,
              title:response.data.title,
              xaxis:response.data.xaxis 
            }
          } else {
            this.payTrendData = null
          }
        }
      })
    },
    
    // 注册趋势
    get_regTrend() {
      const data = {
        appkey: this.appkey,
        startDate: this.$refs['hotkey'].selecttime[0],
        endDate: this.$refs['hotkey'].selecttime[1], 
      }
      find_regTrend(data).then(response => {
        if(response.code == 1) {
          if(response.data) {
            this.regTrendData = {
              dataList:response.data.dataList,
              server:response.data.server,
              subtitle:response.data.subtitle,
              title:response.data.title,
              xaxis:response.data.xaxis 
            }
          } else {
            this.regTrendData = null
          }
        }
      })
    },

    // 推广注册成本
    get_regCost() {
      const data = {
        appkey: this.appkey,
        startDate: this.$refs['hotkey'].selecttime[0],
        endDate: this.$refs['hotkey'].selecttime[1], 
      }
      find_regCost(data).then(response => {
        if(response.code == 1) {
          if(response.data) {
            this.regCostData = {
              dataList:response.data.dataList,
              server:response.data.server,
              subtitle:response.data.subtitle,
              title:response.data.title,
              xaxis:response.data.xaxis 
            }
          } else {
            this.regCostData = null
          }
        }
      })
    },

    // 时间改变 刷新回调
    handleFilter() {
      this.get_recordView() // 获取消耗总览数据
      this.get_payTrend() // 收入趋势
      this.get_regTrend() // 注册趋势
      this.get_regCost() // 推广注册成本
    }
  }
}
</script>

<style lang="scss" scoped>
  .box-card{
    margin: 0px 0px 20px;
    ::v-deep.el-card__header{
      padding: 10px 20px;
      background-color: #f0f2f5;
    }
    ::v-deep .el-card__body{
      padding: 0.5%;
      
    }
  }
  .game-filter{
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin: 5px 10px 15px;
    .label{
      min-width: 77px;
      font-size: 15px;
      color: #7b7b7b; 
    }
  }
  .chart-box{
    
    .item-box{
      margin: 1% 0.5%;
      height: 510px;
      overflow: hidden;
      ::v-deep .el-card__header{
        padding: 8px 20px;
        background-color: #ffffff;
      }
      ::v-deep .el-card__body{
        padding: 10px 0;
      }
      .title-box{
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .title{
          font-size: 15px;
          color: #797878;
        }
        .subtitle{
          font-size: 14px;
          color: #9c9999;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
 ::v-deep .el-select__tags{
    .el-tag {
        max-width: 74%;
        overflow: hidden;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        .el-select__tags-text{
            width: 100%;
            overflow: hidden;
        }
    }
    .el-select__input{
        margin-left: 2px;
    }
 }
  
</style>